import { render, staticRenderFns } from "./custom-base64-file-input.vue?vue&type=template&id=d5722eea"
import script from "./custom-base64-file-input.vue?vue&type=script&lang=js"
export * from "./custom-base64-file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports